<template>
  <v-app>
    <v-main>
      <Snackbar></Snackbar>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Snackbar from './components/events/Snackbar.vue';
import axiosErrorInterceptor from './routes/axios-interceptors';

export default {
  name: 'App',
  components: {
    Snackbar,
  },

  data: () => ({
    //
  }),
  created() {
    axiosErrorInterceptor(this.$store, this.$router);
  },
};
</script>
